export default "__VITE_ASSET__SvmJi5Fs__";